export default __webpack_public_path__ + "static/media/35.d361d40c.jpeg";